/* Fix runtime transitoire (26/07/2026) : le cache de rendu des sections PDP sert encore
   d'anciennes versions du bandeau spec (rangée perf collée à la rangée trust, sans filet).
   Ce script normalise les vieux markups vers le rendu final : une seule boîte,
   rangée perf / filet / rangée trust, avec de l'air. Styles inline uniquement
   (la page cachée référence aussi un ancien scart-theme.css). Idempotent.
   À retirer quand le cache aura convergé partout (quelques jours). */
(function () {
  function grid(el, cols) {
    el.style.display = 'grid';
    el.style.gridTemplateColumns = 'repeat(auto-fit, minmax(' + cols + 'px, 1fr))';
    el.style.gap = '1.4rem 1rem';
  }
  function divider() {
    var d = document.createElement('div');
    d.style.borderTop = '1px solid rgba(18,18,18,0.2)';
    d.style.margin = '1.6rem 0 1.8rem';
    return d;
  }
  function fix() {
    var spec = document.querySelector('.scart-spec-bandeau');
    if (!spec || spec.dataset.scartFixed === '1') return;
    /* Markup final déjà servi ? (contient le filet) → rien à faire */
    if (spec.querySelector('.scart-spec-bandeau__divider')) { spec.dataset.scartFixed = '1'; return; }
    /* Vieux bloc perf séparé : v1 (.scart-perf-bandeau) ou v2 (.scart-spec-bandeau--perf) */
    var perf = document.querySelector('.scart-perf-bandeau, .scart-spec-bandeau--perf');
    if (perf === spec) {
      var all = document.querySelectorAll('.scart-spec-bandeau');
      spec = all.length > 1 ? all[1] : null;
      if (!spec) return;
    }
    if (!perf) { if (spec) spec.dataset.scartFixed = '1'; return; }

    /* Wrap des items trust existants dans une rangée dédiée */
    var trustRow = document.createElement('div');
    while (spec.firstChild) trustRow.appendChild(spec.firstChild);
    grid(trustRow, 150);

    /* Rangée perf : on déplace les items (leurs styles voyagent avec leur <style> inline v1,
       ou avec les classes spec v2) */
    var perfRow = document.createElement('div');
    var items = perf.querySelectorAll(':scope > *');
    for (var i = 0; i < items.length; i++) perfRow.appendChild(items[i]);
    grid(perfRow, 110);

    spec.style.display = 'block';
    spec.style.padding = '2rem 1.4rem';
    spec.style.margin = '2.4rem 0 0.6rem';
    spec.appendChild(perfRow);
    spec.appendChild(divider());
    spec.appendChild(trustRow);
    spec.dataset.scartFixed = '1';
    perf.parentNode && perf.parentNode.removeChild(perf);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix);
  else fix();
})();
